import PreviewLabel from "@/app/shared/PreviewLabel";

import { Paper, Stack } from "@mui/material";
import PropTypes from "prop-types";

export default function AuthUI({ children, onSubmit }) {
  return (
    <Stack
      sx={{
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        height: "100dvh",
      }}
      className="bg-linear-to-br from-violet-100 from-16% via-indigo-200 via-50% to-blue-200 dark:from-violet-900 dark:via-indigo-900 dark:to-blue-950"
    >
      <Paper
        sx={{
          width: 1,
          maxWidth: 360,
          borderRadius: 3,
        }}
      >
        <Stack
          component="form"
          onSubmit={onSubmit}
          sx={{
            gap: 2,
            p: 4,
          }}
        >
          <Stack
            direction="row"
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              pb: 4,
            }}
          >
            <img src={`/${import.meta.env.SIPPY_ICON}`} alt="Sippy logo" height="48px" width="39px" />
            <PreviewLabel />
          </Stack>
          {children}
        </Stack>
      </Paper>
    </Stack>
  );
}

AuthUI.propTypes = {
  children: PropTypes.node,
  onSubmit: PropTypes.func,
};
